import { Component, OnInit, AfterViewInit, ChangeDetectorRef, ViewChild, OnDestroy, TemplateRef, Output, EventEmitter, NgZone } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import * as feather from 'feather-icons';
import { Taxe, TaxeService, ApiResponse } from './taxe.service';
import { NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { ParametreService } from '../../main-parametre/parametre.service';
import { CroudTaxeComponent } from "./croud-taxe/croud-taxe.component";

@Component({
  selector: 'app-parametre-taxe',
  templateUrl: './parametre-taxe.component.html',
  styleUrls: ['./parametre-taxe.component.scss'],
  standalone: true,
  imports: [CommonModule, FormsModule, CroudTaxeComponent]
})
export class ParametreTaxeComponent implements OnInit, AfterViewInit, OnDestroy {
  TaxeList: Taxe[] = [];
  stationId: number | null = null;
  isLoading: boolean = false;
  error: string | null = null;
  private subscriptions = new Subscription();
  private modalSubscriptionCount = 0;
  private componentId = Math.random().toString(36).substring(2);
  private lastEventId: string | null = null;

  @ViewChild('modalLG') modalTemplate!: TemplateRef<any>;
  private modalRef: any = null;
  modalType: 'ajouter' | 'update' | 'etat' = 'ajouter';
  TaxeData: Taxe = {
    id: 0,
    client_id: 1,
    station_id: 1,
    nom: '',
    label: '',
    valeur: 1,
    valeur_fixe: false,
    valeur_pourcentage: true,
    applique_avant_tva: false,
    applique_apres_tva: false,
    applique_tva: false,
    taxe_applique_sur_produits: false,
    type: '+',
    applique_sur_product: false,
    applique_sur_tous_document: false,
    utilisation_tous: true,
    utilisation_vente: false,
    utilisation_achat: false,
    statut: true
  };
  /** Sélection formulaire : mappée vers utilisation_tous / utilisation_vente / utilisation_achat à l’envoi. */
  utilisationMode: 'tous' | 'ventes' | 'achat' = 'tous';
  /** Pendant un PUT sur applique_sur_tous_document (évite double clic). */
  updatingTousDocTaxeId: number | null = null;
  temporaryStatut: boolean | null = null;
  originalStatut: boolean | null = null;
  desiredStatut: boolean | null = null;
  togglingTaxeId: number | null = null;

  confirmationMessage: string | null = null;

  @Output() addTaxeEvent = new EventEmitter<void>();
  @Output() editTaxeEvent = new EventEmitter<Taxe>();
  @Output() toggleTaxeEvent = new EventEmitter<{ taxe: Taxe; newStatut: boolean }>();

  constructor(
    private TaxeService: TaxeService,
    private toastr: ToastrService,
    private router: Router,
    private cdr: ChangeDetectorRef,
    private modalService: NgbModal,
    private parametreService: ParametreService,
    private ngZone: NgZone
  ) {
    this.TaxeList = [];
    //console.log('ParametreTaxeComponent: Constructor called, componentId:', this.componentId);
  }

  ngOnInit(): void {
   // console.log('ParametreTaxeComponent: ngOnInit called, componentId:', this.componentId);
    this.loadUserData();
    this.loadTaxeList();
    if (this.modalSubscriptionCount > 0) {
      console.warn('ParametreTaxeComponent: Already subscribed to openModal$, skipping subscription, componentId:', this.componentId);
      this.toastr.warning('Tentative de souscription multiple détectée', 'Avertissement');
      return;
    }
    const modalSub = this.parametreService.openModal$.subscribe(({ component, action, subType }) => {
      const eventId = `${component}-${action}-${subType || 'none'}-${Date.now()}`;
      if (this.lastEventId === eventId) {
        console.warn('ParametreTaxeComponent: Ignoring duplicate openModal event:', { component, action, subType, eventId, subscriptionCount: this.modalSubscriptionCount, componentId: this.componentId });
        this.toastr.warning('Événement d\'ouverture de modal dupliqué ignoré', 'Avertissement');
        return;
      }
      this.lastEventId = eventId;
      //console.log('ParametreTaxeComponent: Received openModal event:', { component, action, subType, eventId, subscriptionCount: ++this.modalSubscriptionCount, componentId: this.componentId });
      if (component === 'taxe-tva' && action === 'add' && (subType === 'taxe' || !subType)) {
        this.openModal('ajouter');
      }
    });
    this.subscriptions.add(modalSub);
  }

  ngAfterViewInit(): void {
    //console.log('ParametreTaxeComponent: ngAfterViewInit called, componentId:', this.componentId);
    this.replaceFeatherIcons();
  }

  ngOnDestroy(): void {
    //console.log('ParametreTaxeComponent: ngOnDestroy called, unsubscribing, subscriptionCount:', this.modalSubscriptionCount, 'componentId:', this.componentId);
    this.subscriptions.unsubscribe();
    this.modalSubscriptionCount = 0;
    this.lastEventId = null;
    if (this.modalRef) {
      this.modalRef.close();
      this.modalRef = null;
    }
  }

  private loadUserData(): void {
    const user = localStorage.getItem('currentUser');
   // console.log('ParametreTaxeComponent: Current user from localStorage:', user);
    if (user) {
      try {
        const currentUser = JSON.parse(user);
        if (currentUser?.stations?.length > 0) {
          this.stationId = currentUser.stations[0].id;
          this.TaxeData.client_id = currentUser.id;
          this.TaxeData.station_id = this.stationId;
          console.log('ParametreTaxeComponent: Station ID set:', this.stationId, 'Client ID:', this.TaxeData.client_id);
        } else {
          this.toastr.error('Aucune station trouvée. Veuillez créer une station.', 'Erreur');
          console.error('ParametreTaxeComponent: No stations found in currentUser');
        }
      } catch (error) {
        this.toastr.error('Erreur lors de la lecture des données utilisateur.', 'Erreur');
        console.error('ParametreTaxeComponent: Error parsing currentUser:', error);
      }
    } else {
      this.toastr.error('Utilisateur non connecté.', 'Erreur');
      console.error('ParametreTaxeComponent: No currentUser in localStorage');
    }
  }

  private loadTaxeList(): void {
    if (this.stationId === null) {
      this.toastr.error('Aucune station disponible pour charger les taxes.', 'Erreur');
      return;
    }
    this.isLoading = true;
    this.TaxeService.getTaxeList(this.stationId).subscribe({
      next: (response: ApiResponse) => {
        console.log('ParametreTaxeComponent: Load Taxe List response:', response);
        this.isLoading = false;
        if (response.success && response.taxes && Array.isArray(response.taxes)) {
          response.taxes.forEach(taxe => this.updateTaxeList(taxe));
          this.ngZone.run(() => this.cdr.detectChanges());
          this.replaceFeatherIcons();
        } else {
          this.error = 'Échec du chargement des taxes: ' + (response.message || 'Réponse inattendue');
          this.toastr.error(this.error, 'Erreur');
          console.error('ParametreTaxeComponent: Load Taxe List failed:', response);
        }
      },
      error: (error) => {
        this.isLoading = false;
        this.error = 'Erreur lors du chargement des taxes: ' + (error.message || 'Erreur inconnue');
        this.toastr.error(this.error, 'Erreur');
        console.error('ParametreTaxeComponent: Load Taxe List error:', error);
      }
    });
  }

  private updateTaxeList(updatedTaxe: Taxe): void {
    const index = this.TaxeList.findIndex(t => t.id === updatedTaxe.id);
    if (index !== -1) {
      this.TaxeList = [
        ...this.TaxeList.slice(0, index),
        { ...this.TaxeList[index], ...updatedTaxe },
        ...this.TaxeList.slice(index + 1)
      ];
    } else {
      this.TaxeList = [...this.TaxeList, updatedTaxe];
    }
    this.ngZone.run(() => {
      this.cdr.detectChanges();
      this.replaceFeatherIcons();
    });
  }

  replaceFeatherIcons(): void {
    try {
      feather.replace();
      console.log('Feather Icons replaced successfully');
    } catch (error) {
      console.error('Error replacing Feather Icons:', error);
    }
  }

    getTaxeValue(taxe: Taxe): string {
        return `${taxe.type}${taxe.valeur}${taxe.valeur_pourcentage ? '%' : ' TND'}`;
    }

    /** Libellé « Contexte » selon utilisation_* (API), avec repli sur l’ancien applique_sur_product. */
    getUtilisationLabel(taxe: Taxe): string {
      if (taxe.utilisation_vente && taxe.utilisation_achat) {
        return 'Ventes & Achat';
      }
      if (taxe.utilisation_vente) {
        return 'Ventes';
      }
      if (taxe.utilisation_achat) {
        return 'Achat';
      }
      if (taxe.utilisation_tous) {
        return 'Tous';
      }
      return taxe.applique_sur_product ? 'Produits' : 'Tous';
    }

    private syncUtilisationModeFromTaxe(taxe: Taxe): void {
      if (taxe.utilisation_vente) {
        this.utilisationMode = 'ventes';
      } else if (taxe.utilisation_achat) {
        this.utilisationMode = 'achat';
      } else {
        this.utilisationMode = 'tous';
      }
    }

    private applyUtilisationFlagsToTaxeData(): void {
      const m = this.utilisationMode;
      this.TaxeData.utilisation_tous = m === 'tous';
      this.TaxeData.utilisation_vente = m === 'ventes';
      this.TaxeData.utilisation_achat = m === 'achat';
    }

    openModal(type: 'ajouter' | 'update' | 'etat' = 'ajouter', taxe?: Taxe, statut?: boolean): void {
        this.modalType = type;
        this.resetForm();

        if (type === 'update' && taxe) {
            const appliqueTva = !!(taxe.applique_tva ?? taxe.applique_a_la_tva);
            // Initialize TaxeData with all properties from the selected taxe
            this.TaxeData = {
                id: taxe.id || 0,
                client_id: this.TaxeData.client_id || taxe.client_id || 1,
                station_id: this.TaxeData.station_id || taxe.station_id || 1,
                nom: taxe.nom || '',
                label: taxe.label || taxe.nom || '',
                valeur: taxe.valeur || 1,
                valeur_fixe: taxe.valeur_pourcentage === false, // Explicitly set to true if valeur_pourcentage is false
                valeur_pourcentage: taxe.valeur_pourcentage === true, // Explicitly set to true if valeur_pourcentage is true
                applique_avant_tva: appliqueTva ? false : !!taxe.applique_avant_tva,
                applique_apres_tva: appliqueTva ? false : !!taxe.applique_apres_tva,
                applique_tva: appliqueTva,
                taxe_applique_sur_produits: appliqueTva ? false : !!taxe.taxe_applique_sur_produits,
                type: taxe.type || '+',
                applique_sur_product: taxe.applique_sur_product === true, // Explicitly set to true if applique_sur_product is true
                applique_sur_tous_document: !!(taxe as any).applique_sur_tous_document,
                utilisation_tous: taxe.utilisation_tous ?? true,
                utilisation_vente: taxe.utilisation_vente ?? false,
                utilisation_achat: taxe.utilisation_achat ?? false,
                statut: !!taxe.statut
            };
            this.syncUtilisationModeFromTaxe(taxe);
            this.applyUtilisationFlagsToTaxeData();
        } else if (type === 'etat' && taxe) {
            this.TaxeData = { ...taxe, client_id: this.TaxeData.client_id, station_id: this.TaxeData.station_id };
            this.originalStatut = taxe.statut;
            this.temporaryStatut = taxe.statut;
            this.desiredStatut = statut;
            this.togglingTaxeId = taxe.id;
            this.confirmationMessage = `Êtes-vous sûr de vouloir ${statut ? 'activer' : 'désactiver'} la taxe ${taxe.nom} (${taxe.valeur}${taxe.valeur_pourcentage ? '%' : ' TND'}) ?`;
        }

        const options: NgbModalOptions = {
            size: 'lg',
            windowClass: 'custom-modal-width',
            centered: true,
            backdrop: 'static',
            keyboard: false
        };

        try {
            this.modalRef = this.modalService.open(this.modalTemplate, options);
            this.ngZone.run(() => this.cdr.detectChanges()); // Force change detection after modal opens
            console.log('ParametreTaxeComponent: Modal opened successfully for type:', type, 'TaxeData:', this.TaxeData);
        } catch (error) {
            console.error('ParametreTaxeComponent: Error opening modal:', error);
            this.toastr.error('Erreur lors de l\'ouverture du modal', 'Erreur');
        }
    }

  resetForm(): void {
    this.utilisationMode = 'tous';
    this.TaxeData = {
      id: 0,
      client_id: this.TaxeData.client_id || 1,
      station_id: this.TaxeData.station_id || 1,
      nom: '',
      label: '',
      valeur: 1,
      valeur_fixe: false,
      valeur_pourcentage: true,
      applique_avant_tva: false,
      applique_apres_tva: false,
      applique_tva: false,
      taxe_applique_sur_produits: false,
      type: '+',
      applique_sur_product: false,
      applique_sur_tous_document: false,
      utilisation_tous: true,
      utilisation_vente: false,
      utilisation_achat: false,
      statut: true
    };
    this.temporaryStatut = null;
    this.originalStatut = null;
    this.desiredStatut = null;
    this.togglingTaxeId = null;
    this.confirmationMessage = null;
  }

  cancelModal(): void {
    //this.toastr.info('Action annulée', 'Information');
    if (this.modalRef && this.modalType === 'etat' && this.togglingTaxeId !== null) {
      const taxeIndex = this.TaxeList.findIndex(t => t.id === this.togglingTaxeId);
      if (taxeIndex !== -1) {
        this.TaxeList = [...this.TaxeList.slice(0, taxeIndex), { ...this.TaxeList[taxeIndex], statut: this.originalStatut || false }, ...this.TaxeList.slice(taxeIndex + 1)];
        this.ngZone.run(() => {
          this.cdr.detectChanges();
          this.replaceFeatherIcons();
        });
      }
    }
    if (this.modalRef) {
      this.modalRef.dismiss('Cancel click');
      this.modalRef = null;
      console.log('ParametreTaxeComponent: Modal dismissed, TaxeList:', this.TaxeList);
    }
    this.resetForm();
  }

  onSubmit(form: any): void {
    console.log('ParametreTaxeComponent: onSubmit called, form value:', form.value, 'form valid:', form.valid, 'TaxeData:', this.TaxeData, 'TaxeList:', this.TaxeList);
    if (this.stationId === null) {
      this.toastr.error('Aucune station disponible.', 'Erreur');
      console.error('ParametreTaxeComponent: No stationId available');
      return;
    }

    if (!form.valid && this.modalType !== 'etat') {
      this.toastr.error('Veuillez remplir tous les champs requis.', 'Erreur');
      console.warn('ParametreTaxeComponent: Form is invalid:', form.errors, 'Controls:', form.controls);
      return;
    }

    this.applyUtilisationFlagsToTaxeData();
    const taxe = { ...this.TaxeData };
    // Si applique_tva est true, forcer les autres à false avant envoi
    if (taxe.applique_tva) {
      taxe.applique_avant_tva = false;
      taxe.applique_apres_tva = false;
      taxe.taxe_applique_sur_produits = false;
    }
    console.log('ParametreTaxeComponent: Submitting Taxe:', taxe);

    if (this.modalType === 'etat' && this.TaxeData.id !== 0) {
      if (this.desiredStatut === null || this.desiredStatut === this.originalStatut) {
        this.toastr.warning('Aucun changement détecté pour le statut.', 'Avertissement');
        this.modalRef!.close();
        this.modalRef = null;
        this.resetForm();
        return;
      }
      const taxeIndex = this.TaxeList.findIndex(t => t.id === this.togglingTaxeId);
      if (taxeIndex !== -1) {
        this.TaxeList = [...this.TaxeList.slice(0, taxeIndex), { ...this.TaxeList[taxeIndex], statut: this.desiredStatut || false }, ...this.TaxeList.slice(taxeIndex + 1)];
        this.ngZone.run(() => {
          this.cdr.detectChanges();
          this.replaceFeatherIcons();
        });
      }

      const updatedTaxe = { ...this.TaxeData, statut: this.desiredStatut };
      this.TaxeService.updateTaxe(updatedTaxe, this.stationId).subscribe({
        next: (response: ApiResponse) => {
          console.log('ParametreTaxeComponent: Update Taxe response:', response);
          if (response.success) {
            if (response.taxes && Array.isArray(response.taxes)) {
              response.taxes.forEach(taxe => this.updateTaxeList(taxe));
            } else if (response.taxe) {
              this.updateTaxeList(response.taxe);
            } else {
              if (taxeIndex !== -1) {
                this.TaxeList = [...this.TaxeList.slice(0, taxeIndex), { ...this.TaxeList[taxeIndex], statut: this.desiredStatut || false }, ...this.TaxeList.slice(taxeIndex + 1)];
              }
            }
            this.ngZone.run(() => {
              this.cdr.detectChanges();
              this.replaceFeatherIcons();
              this.toastr.success(`Taxe ${updatedTaxe.statut ? 'activée' : 'désactivée'} avec succès`, 'Succès');
            });
            this.modalRef!.close('Accept click');
            this.modalRef = null;
          } else {
            this.toastr.error('Échec du changement de statut de la taxe: ' + (response.message || 'Erreur inconnue'), 'Erreur');
            console.error('ParametreTaxeComponent: Update Taxe response unsuccessful:', response);
            if (taxeIndex !== -1) {
              this.TaxeList = [...this.TaxeList.slice(0, taxeIndex), { ...this.TaxeList[taxeIndex], statut: this.originalStatut || false }, ...this.TaxeList.slice(taxeIndex + 1)];
              this.ngZone.run(() => {
                this.cdr.detectChanges();
                this.replaceFeatherIcons();
              });
            }
          }
        },
        error: (error) => {
          this.toastr.error('Erreur lors du changement de statut: ' + (error.message || 'Erreur inconnue'), 'Erreur');
          console.error('ParametreTaxeComponent: Update status error:', error);
          const taxeIndex = this.TaxeList.findIndex(t => t.id === this.togglingTaxeId);
          if (taxeIndex !== -1) {
            this.TaxeList = [...this.TaxeList.slice(0, taxeIndex), { ...this.TaxeList[taxeIndex], statut: this.originalStatut || false }, ...this.TaxeList.slice(taxeIndex + 1)];
            this.ngZone.run(() => {
              this.cdr.detectChanges();
              this.replaceFeatherIcons();
            });
          }
        }
      });
      this.resetForm();
    } else if (this.modalType === 'ajouter') {
      this.TaxeService.createTaxe(taxe, this.stationId).subscribe({
        next: (response: ApiResponse) => {
          console.log('ParametreTaxeComponent: Create Taxe response:', JSON.stringify(response, null, 2));
          if (response.success) {
            if (response.taxes && Array.isArray(response.taxes)) {
              response.taxes.forEach(taxe => this.updateTaxeList(taxe));
            } else if (response.taxe) {
              this.updateTaxeList(response.taxe);
            } else {
              this.toastr.error('Réponse inattendue du serveur: aucun taxe retourné.', 'Erreur');
              console.error('ParametreTaxeComponent: Create Taxe response unexpected:', response);
            }
            this.ngZone.run(() => {
              this.cdr.detectChanges();
              this.replaceFeatherIcons();
              this.toastr.success('Taxe ajoutée avec succès', 'Succès');
            });
            this.modalRef!.close('Accept click');
            this.modalRef = null;
          } else {
            this.toastr.error('Échec de l\'ajout de la taxe: ' + (response.message || 'Réponse inattendue'), 'Erreur');
            console.error('ParametreTaxeComponent: Create Taxe response unsuccessful:', JSON.stringify(response, null, 2));
          }
        },
        error: (error) => {
          this.toastr.error('Erreur lors de l\'ajout: ' + (error.message || 'Erreur inconnue'), 'Erreur');
          console.error('ParametreTaxeComponent: Create error:', error);
        }
      });
    } else if (this.modalType === 'update' && this.TaxeData.id !== 0) {
      const originalTaxe = this.TaxeList.find(t => t.id === this.TaxeData.id);
      if (originalTaxe && JSON.stringify(originalTaxe) === JSON.stringify(taxe)) {
        this.toastr.warning('Aucun changement détecté pour la mise à jour.', 'Avertissement');
        this.modalRef!.close();
        this.modalRef = null;
        return;
      }
      this.TaxeService.updateTaxe(taxe, this.stationId).subscribe({
        next: (response: ApiResponse) => {
          console.log('ParametreTaxeComponent: Update Taxe response:', response);
          if (response.success) {
            if (response.taxes && Array.isArray(response.taxes)) {
              response.taxes.forEach(taxe => this.updateTaxeList(taxe));
            } else if (response.taxe) {
              this.updateTaxeList(response.taxe);
            } else {
              this.toastr.error('Réponse inattendue du serveur: aucun taxe mis à jour.', 'Erreur');
              console.error('ParametreTaxeComponent: Unexpected response format:', response);
            }
            this.ngZone.run(() => {
              this.cdr.detectChanges();
              this.replaceFeatherIcons();
              this.toastr.success('Taxe mise à jour avec succès', 'Succès');
            });
            this.modalRef!.close('Accept click');
            this.modalRef = null;
          } else {
            this.toastr.error('Échec de la mise à jour de la taxe: ' + (response.message || 'Erreur inconnue'), 'Erreur');
            console.error('ParametreTaxeComponent: Update Taxe response unsuccessful:', response);
          }
        },
        error: (error) => {
          this.toastr.error('Erreur lors de la mise à jour: ' + (error.message || 'Erreur inconnue'), 'Erreur');
          console.error('ParametreTaxeComponent: Update error:', error);
        }
      });
    }
  }

    incrementValue(): void {
        if (this.TaxeData.valeur.toString().length < 10) {
            let newValue = (this.TaxeData.valeur ?? 0) + 0.1;
            if (newValue > 10) newValue = 10;

            // Arrondir à 1 décimale et supprimer les zéros inutiles
            this.TaxeData.valeur = parseFloat(newValue.toFixed(1));
        }
    }

    decrementValue(): void {
        if (this.TaxeData.valeur > 0) {
            let newValue = (this.TaxeData.valeur ?? 0) - 0.1;
            if (newValue < 0) newValue = 0;

            // Arrondir à 1 décimale et supprimer les zéros inutiles
            this.TaxeData.valeur = parseFloat(newValue.toFixed(1));
        }
    }

  /** Si applique_tva est true, applique_avant_tva, applique_apres_tva et taxe_applique_sur_produits doivent être false. */
  onAppliqueTvaChange(): void {
    if (this.TaxeData.applique_tva) {
      this.TaxeData.applique_avant_tva = false;
      this.TaxeData.applique_apres_tva = false;
      this.TaxeData.taxe_applique_sur_produits = false;
    }
  }

  addTaxe(): void {
    console.log('ParametreTaxeComponent: addTaxe called, componentId:', this.componentId);
    this.openModal('ajouter');
    this.addTaxeEvent.emit();
  }

  editTaxe(taxe: Taxe): void {
    console.log('ParametreTaxeComponent: editTaxe called for Taxe:', taxe, 'componentId:', this.componentId);
    this.openModal('update', taxe);
    this.editTaxeEvent.emit(taxe);
  }

  toggleTaxe(taxe: Taxe, event: Event): void {
    event.preventDefault();
    const currentStatut = taxe.statut;
    this.openModal('etat', taxe, !currentStatut);
    this.toggleTaxeEvent.emit({ taxe, newStatut: !currentStatut });
    const taxeIndex = this.TaxeList.findIndex(t => t.id === taxe.id);
    if (taxeIndex !== -1) {
      this.TaxeList = [...this.TaxeList.slice(0, taxeIndex), { ...this.TaxeList[taxeIndex], statut: currentStatut }, ...this.TaxeList.slice(taxeIndex + 1)];
      this.ngZone.run(() => {
        this.cdr.detectChanges();
        this.replaceFeatherIcons();
      });
    }
  }

  /** Vérifie applique_sur_tous_document (bool ou 0/1 côté API). */
  isAppliqueSurTousDocument(taxe: Taxe): boolean {
    const v = (taxe as any).applique_sur_tous_document;
    return v === true || v === 1 || v === '1';
  }

  /**
   * PUT /api/settings/taxe/:stationId/:taxeId avec applique_sur_tous_document à true ou false.
   */
  onAppliqueSurTousDocumentChange(taxe: Taxe, checked: boolean): void {
    if (this.stationId == null || !taxe.id) {
      this.toastr.error('Station ou taxe invalide.', 'Erreur');
      return;
    }
    if (this.updatingTousDocTaxeId === taxe.id) {
      return;
    }
    const prev = this.isAppliqueSurTousDocument(taxe);
    if (checked === prev) {
      return;
    }

    const idx = this.TaxeList.findIndex((t) => t.id === taxe.id);
    if (idx !== -1) {
      this.TaxeList = [
        ...this.TaxeList.slice(0, idx),
        { ...this.TaxeList[idx], applique_sur_tous_document: checked },
        ...this.TaxeList.slice(idx + 1)
      ];
    }

    this.updatingTousDocTaxeId = taxe.id;
    const payload: Taxe = {
      ...taxe,
      applique_sur_tous_document: checked
    };

    this.TaxeService.updateTaxe(payload, this.stationId).subscribe({
      next: (response) => {
        this.updatingTousDocTaxeId = null;
        if (response.success) {
          if (response.taxe) {
            this.updateTaxeList(response.taxe);
          } else if (response.taxes?.length) {
            response.taxes.forEach((t) => this.updateTaxeList(t));
          }
          this.toastr.success(
            checked ? 'Taxe appliquée sur tous les documents.' : 'Application sur tous les documents désactivée.',
            'Succès'
          );
        } else {
          this.revertAppliqueSurTousDoc(idx, prev);
          this.toastr.error(response.message || 'Mise à jour impossible.', 'Erreur');
        }
        this.cdr.detectChanges();
        this.replaceFeatherIcons();
      },
      error: () => {
        this.updatingTousDocTaxeId = null;
        this.revertAppliqueSurTousDoc(idx, prev);
        this.toastr.error('Erreur lors de la mise à jour.', 'Erreur');
        this.cdr.detectChanges();
        this.replaceFeatherIcons();
      }
    });
  }

  private revertAppliqueSurTousDoc(idx: number, prev: boolean): void {
    if (idx < 0) {
      return;
    }
    this.TaxeList = [
      ...this.TaxeList.slice(0, idx),
      { ...this.TaxeList[idx], applique_sur_tous_document: prev },
      ...this.TaxeList.slice(idx + 1)
    ];
  }
}
